module.exports = __webpack_public_path__ + "img/heatex-W-idle.e13fec5c.png";